(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-mosaic"] && !Shopify.designMode) return;
  try {
    
  /* Playback gating only; the layout needs no JavaScript.
     Videos are emitted without `autoplay` and start when they scroll into view,
     pausing again when they leave, so only on-screen media decodes. */
  (function () {
    var observed = new WeakSet();
    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              video.muted = true;
              video.playsInline = true;
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '25% 0px' })
      : null;

    function init(root) {
      root.querySelectorAll('.mosaic video').forEach(function (video) {
        if (observed.has(video)) return;
        observed.add(video);
        if (io) {
          io.observe(video);
        } else {
          video.muted = true;
          video.playsInline = true;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    /* Theme editor re-renders the section on add / reorder / delete. */
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
